import { ISaveBlocker, ValidationSaveBlockerType } from "./interface";

/**
 * Creates a singleton blocker set for field-level validation warnings.
 *
 * @param type - Category type for the blocker (e.g., "phase", "reportType").
 * @param warningText - Warning text for the blocker, or undefined to clear it.
 * @returns A set containing the blocker when a warning exists, otherwise an empty set.
 */
export const createSingletonSaveBlockerSet = (
  type: ValidationSaveBlockerType,
  warningText?: string,
): Set<ISaveBlocker> => (warningText ? new Set([{ id: type, type, warningText }]) : new Set());
